import { Link } from "react-router-dom";

import logo from "../../assets/carbase-logo.png";

const Header = () => {
  return (
    <header>
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="flex items-center justify-between h-16">
          <Link to="/" className="hover:text-white transition-colors">
            <div className="flex items-center space-x-2">
              <img
                src={logo}
                alt="Logo"
                className="h-10 mt-2 object-cover group-hover:scale-105 transition-transform duration-300"
              />
            </div>
          </Link>
          <nav className="hidden md:flex space-x-8">
            <Link
              to="/"
              className="text-gray-700 hover:text-blue-600 transition-colors"
            >
              Browse Vehicles
            </Link>
            {/* <Link
              to="/"
              className="text-gray-700 hover:text-blue-600 transition-colors"
            >
              Sell Your Vehicle
            </Link> */}
            {/* <Link
              to="/"
              className="text-gray-700 hover:text-blue-600 transition-colors"
            >
              Financing
            </Link> */}
            <Link
              to="/contact"
              className="text-gray-700 hover:text-blue-600 transition-colors"
            >
              Contact
            </Link>
          </nav>
        </div>
      </div>
    </header>
  );
};

export default Header;
